import { render, staticRenderFns } from "./semak.vue?vue&type=template&id=17a0e057&"
import script from "./semak.vue?vue&type=script&lang=js&"
export * from "./semak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports